module.exports = __webpack_public_path__ + "img/stanislav_safronov-min.40f2085d.jpg";